<div class="account-result-page">
    <div id="result-logo">
        <img src="/assets/workroads-logo-login.svg" alt="workroads logo" />
    </div>
    <ng-content select="#result-subtitle"></ng-content>
    <ng-content select="#result-text"></ng-content>
    <ng-content select="#result-image"></ng-content>
    <ng-content></ng-content>
</div>
